import { http, httpFile } from './http_service';

//Get all
export function leadsSendStatusUpdate(obj){
    return http().post('/notification/leads/send-status-update', obj);
}
